import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "11",
      fill: "#EDBB0C"
    }, null, -1),
    _createElementVNode("ellipse", {
      cx: "12",
      cy: "12",
      rx: "8.9375",
      ry: "8.9375",
      stroke: "#FFF3CA",
      "stroke-width": "0.458333"
    }, null, -1),
    _createElementVNode("ellipse", {
      cx: "12",
      cy: "12",
      rx: "8.9375",
      ry: "8.9375",
      fill: "#FFE057"
    }, null, -1)
  ]))]))
}
export default { render: render }